import * as React from "react";
import { Component } from "react";
import {MDBIcon, MDBContainer, MDBCard, MDBCardBody, MDBCardHeader, MDBCollapse,} from 'mdbreact';
import Swal from 'sweetalert2';
import { ProductosConfiguracion_ } from '../../services/WebAPI_Utrahuilca';
import AOS from 'aos';
import 'aos/dist/aos.css';

class PreguntasFrecuentesProducto extends Component {
    static displayName = PreguntasFrecuentesProducto.name;
    constructor(props) {
        super(props);
        this.state = {
            preguntas: [],
            loading: true,
            openItems: {}
        };
    }

    async componentDidMount() {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: false,
        });

        const { idprodutra } = this.props;
        const data = {
            tran: 8,
            idprodutra: idprodutra,
            descripcion: "NA",
            manejarutaimg: 0,
            rutaimg: "NA",
            usucrea: "NA",
            feccrea: Date,
            titulo: "NA",
            orden: 0,
            iditem: 4,
            estado: 1,
            idconfigitem: 0,
        };

        try {
            const response = await ProductosConfiguracion_(data);
            if (response.data.length > 0 && !response.data[0].message) {
                const preguntas = response.data.map(item => ({
                    id: item.iditem,
                    idprodutra: item.idprodutra,
                    orden: item.orden,
                    titulo: item.titulo,
                    descripcion: item.descripcion,
                }));

                this.setState({ preguntas, loading: false });
            } else {
                this.setState({ preguntas: [], loading: false });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: 'Ocurrió un error al consumir el servicio'
            });
            this.setState({ loading: false });
        }
    }

    toggleItem = (id) => {
        this.setState(prevState => ({
            openItems: {
                ...prevState.openItems,
                [id]: !prevState.openItems[id]
            }
        }));
    }

    render() {
        const { preguntas, openItems, loading } = this.state;

        if (loading) {
            return (
                <p className="text-center text-gray-500"><em>Cargando...</em></p>
            );
        }

        return (
            <MDBContainer className="my-4 p-4">
                <h2 className="fs-1 fs-sm-1 fs-md-2 fs-lg-3 fw-bold text-center text-md-start font-weight-bold" data-aos="fade-right">Preguntas Frecuentes</h2>
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', justifyContent: 'center' }}>
                    <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', borderRadius: '2px', width: '60px' }}></div>
                    <div style={{ height: '4px', backgroundColor: 'rgb(240, 127, 0)', borderRadius: '2px', width: '30px' }}></div>
                </div>

                {preguntas.length === 0 && (
                    <>
                        <p className="text-center text-gray-500" data-aos="fade-right"><em>No hay preguntas frecuentes disponibles en este momento.</em></p>
                    </>
                )}

                {/*AJUSTE PRF - RQTO AHORRO Y CDAT DIGITAL JPG NOV 2025*/}
                {/*{preguntas.map((item) => (}
                    <MDBCard key={item.orden} className="mb-2" data-aos="fade-up" style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.09)' }}>
                        <MDBCardHeader
                            onClick={() => this.toggleItem(item.orden)}}
                            className="d-flex justify-content-between align-items-center"
                            style={{ cursor: 'pointer', backgroundColor: '#ffffff' }}
                        >}
                            <span>{item.titulo}</span>
                            <MDBIcon icon={openItems[item.rutaimg] ? 'angle-up' : 'angle-down'} />
                        </MDBCardHeader>
                        <MDBCollapse isOpen={openItems[item.orden]}>
                            <MDBCardBody>{item.descripcion}</MDBCardBody>
                        </MDBCollapse>
                    </MDBCard>
                ))}*/}
                {preguntas.map((item, index) => (
                    <MDBCard key={index} className="mb-2" data-aos="fade-up" style={{ boxShadow: '0 2px 4px rgba(0, 0, 0, 0.09)' }}>
                        <MDBCardHeader
                            onClick={() => this.toggleItem(index)}
                            className="d-flex justify-content-between align-items-center"
                            style={{ cursor: 'pointer', backgroundColor: '#ffffff' }}
                        >
                            <span>{item.titulo}</span>
                            <MDBIcon icon={openItems[item.rutaimg] ? 'angle-up' : 'angle-down'} />
                        </MDBCardHeader>
                        <MDBCollapse isOpen={openItems[index]}>
                            <MDBCardBody>{item.descripcion}</MDBCardBody>
                        </MDBCollapse>
                    </MDBCard>
                ))}
            </MDBContainer>
        );
    }
}

export default PreguntasFrecuentesProducto;